'use strict';

var _regeneratorRuntime = require("/codebuild/output/src3315055034/src/node_modules/@babel/runtime/regenerator/index.js");

var _slicedToArray = require("/codebuild/output/src3315055034/src/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _defineProperty = require("/codebuild/output/src3315055034/src/node_modules/@babel/runtime/helpers/defineProperty.js");

var _asyncToGenerator = require("/codebuild/output/src3315055034/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Token = require('token-types');

var strtok3 = require('strtok3/lib/core');

var _require = require('./util'),
    stringToBytes = _require.stringToBytes,
    tarHeaderChecksumMatches = _require.tarHeaderChecksumMatches,
    uint32SyncSafeToken = _require.uint32SyncSafeToken;

var supported = require('./supported');

var minimumBytes = 4100; // A fair amount of file-types are detectable within this range

function fromStream(_x) {
  return _fromStream.apply(this, arguments);
}

function _fromStream() {
  _fromStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(stream) {
    var tokenizer;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return strtok3.fromStream(stream);

          case 2:
            tokenizer = _context2.sent;
            _context2.prev = 3;
            _context2.next = 6;
            return fromTokenizer(tokenizer);

          case 6:
            return _context2.abrupt("return", _context2.sent);

          case 7:
            _context2.prev = 7;
            _context2.next = 10;
            return tokenizer.close();

          case 10:
            return _context2.finish(7);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3,, 7, 11]]);
  }));
  return _fromStream.apply(this, arguments);
}

function fromBuffer(_x2) {
  return _fromBuffer.apply(this, arguments);
}

function _fromBuffer() {
  _fromBuffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(input) {
    var buffer, tokenizer;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (input instanceof Uint8Array || input instanceof ArrayBuffer || Buffer.isBuffer(input)) {
              _context3.next = 2;
              break;
            }

            throw new TypeError("Expected the `input` argument to be of type `Uint8Array` or `Buffer` or `ArrayBuffer`, got `".concat(typeof input, "`"));

          case 2:
            buffer = input instanceof Buffer ? input : Buffer.from(input);

            if (buffer && buffer.length > 1) {
              _context3.next = 5;
              break;
            }

            return _context3.abrupt("return");

          case 5:
            tokenizer = strtok3.fromBuffer(buffer);
            return _context3.abrupt("return", fromTokenizer(tokenizer));

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _fromBuffer.apply(this, arguments);
}

function _check(buffer, headers, options) {
  options = _objectSpread({
    offset: 0
  }, options);

  var _iterator = _createForOfIteratorHelper(headers.entries()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
          index = _step$value[0],
          header = _step$value[1];

      // If a bitmask is set
      if (options.mask) {
        // If header doesn't equal `buf` with bits masked off
        if (header !== (options.mask[index] & buffer[index + options.offset])) {
          return false;
        }
      } else if (header !== buffer[index + options.offset]) {
        return false;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return true;
}

function fromTokenizer(_x3) {
  return _fromTokenizer2.apply(this, arguments);
}

function _fromTokenizer2() {
  _fromTokenizer2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(tokenizer) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            return _context4.abrupt("return", _fromTokenizer(tokenizer));

          case 4:
            _context4.prev = 4;
            _context4.t0 = _context4["catch"](0);

            if (_context4.t0 instanceof strtok3.EndOfStreamError) {
              _context4.next = 8;
              break;
            }

            throw _context4.t0;

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 4]]);
  }));
  return _fromTokenizer2.apply(this, arguments);
}

function _fromTokenizer(_x4) {
  return _fromTokenizer3.apply(this, arguments);
}

function _fromTokenizer3() {
  _fromTokenizer3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(tokenizer) {
    var buffer, bytesRead, check, checkString, id3HeaderLen, zipHeader, type, mimeType, nextHeaderIndex, _type, brandMajor, maxBufferSize, _buffer, readField, readElement, readChildren, re, docType, str, readChunkHeader, chunk, readHeader, header, payload, typeId, _type2, jsonSize, _header, json;

    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            buffer = Buffer.alloc(minimumBytes);
            bytesRead = 12;

            check = function check(header, options) {
              return _check(buffer, header, options);
            };

            checkString = function checkString(header, options) {
              return check(stringToBytes(header), options);
            }; // Keep reading until EOF if the file size is unknown.


            if (!tokenizer.fileInfo.size) {
              tokenizer.fileInfo.size = Number.MAX_SAFE_INTEGER;
            }

            _context10.next = 7;
            return tokenizer.peekBuffer(buffer, {
              length: bytesRead,
              mayBeLess: true
            });

          case 7:
            if (!check([0x42, 0x4D])) {
              _context10.next = 9;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'bmp',
              mime: 'image/bmp'
            });

          case 9:
            if (!check([0x0B, 0x77])) {
              _context10.next = 11;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'ac3',
              mime: 'audio/vnd.dolby.dd-raw'
            });

          case 11:
            if (!check([0x78, 0x01])) {
              _context10.next = 13;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'dmg',
              mime: 'application/x-apple-diskimage'
            });

          case 13:
            if (!check([0x4D, 0x5A])) {
              _context10.next = 15;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'exe',
              mime: 'application/x-msdownload'
            });

          case 15:
            if (!check([0x25, 0x21])) {
              _context10.next = 21;
              break;
            }

            _context10.next = 18;
            return tokenizer.peekBuffer(buffer, {
              length: 24,
              mayBeLess: true
            });

          case 18:
            if (!(checkString('PS-Adobe-', {
              offset: 2
            }) && checkString(' EPSF-', {
              offset: 14
            }))) {
              _context10.next = 20;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'eps',
              mime: 'application/eps'
            });

          case 20:
            return _context10.abrupt("return", {
              ext: 'ps',
              mime: 'application/postscript'
            });

          case 21:
            if (!(check([0x1F, 0xA0]) || check([0x1F, 0x9D]))) {
              _context10.next = 23;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'Z',
              mime: 'application/x-compress'
            });

          case 23:
            if (!check([0xFF, 0xD8, 0xFF])) {
              _context10.next = 25;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'jpg',
              mime: 'image/jpeg'
            });

          case 25:
            if (!check([0x49, 0x49, 0xBC])) {
              _context10.next = 27;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'jxr',
              mime: 'image/vnd.ms-photo'
            });

          case 27:
            if (!check([0x1F, 0x8B, 0x8])) {
              _context10.next = 29;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'gz',
              mime: 'application/gzip'
            });

          case 29:
            if (!check([0x42, 0x5A, 0x68])) {
              _context10.next = 31;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'bz2',
              mime: 'application/x-bzip2'
            });

          case 31:
            if (!checkString('ID3')) {
              _context10.next = 42;
              break;
            }

            _context10.next = 34;
            return tokenizer.ignore(6);

          case 34:
            _context10.next = 36;
            return tokenizer.readToken(uint32SyncSafeToken);

          case 36:
            id3HeaderLen = _context10.sent;

            if (!(tokenizer.position + id3HeaderLen > tokenizer.fileInfo.size)) {
              _context10.next = 39;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'mp3',
              mime: 'audio/mpeg'
            });

          case 39:
            _context10.next = 41;
            return tokenizer.ignore(id3HeaderLen);

          case 41:
            return _context10.abrupt("return", fromTokenizer(tokenizer));

          case 42:
            if (!checkString('MP+')) {
              _context10.next = 44;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'mpc',
              mime: 'audio/x-musepack'
            });

          case 44:
            if (!((buffer[0] === 0x43 || buffer[0] === 0x46) && check([0x57, 0x53], {
              offset: 1
            }))) {
              _context10.next = 46;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'swf',
              mime: 'application/x-shockwave-flash'
            });

          case 46:
            if (!check([0x47, 0x49, 0x46])) {
              _context10.next = 48;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'gif',
              mime: 'image/gif'
            });

          case 48:
            if (!checkString('FLIF')) {
              _context10.next = 50;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'flif',
              mime: 'image/flif'
            });

          case 50:
            if (!checkString('8BPS')) {
              _context10.next = 52;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'psd',
              mime: 'image/vnd.adobe.photoshop'
            });

          case 52:
            if (!checkString('WEBP', {
              offset: 8
            })) {
              _context10.next = 54;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'webp',
              mime: 'image/webp'
            });

          case 54:
            if (!checkString('MPCK')) {
              _context10.next = 56;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'mpc',
              mime: 'audio/x-musepack'
            });

          case 56:
            if (!checkString('FORM')) {
              _context10.next = 58;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'aif',
              mime: 'audio/aiff'
            });

          case 58:
            if (!checkString('icns', {
              offset: 0
            })) {
              _context10.next = 60;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'icns',
              mime: 'image/icns'
            });

          case 60:
            if (!check([0x50, 0x4B, 0x3, 0x4])) {
              _context10.next = 121;
              break;
            }

            _context10.prev = 61;

          case 62:
            if (!(tokenizer.position + 30 < tokenizer.fileInfo.size)) {
              _context10.next = 114;
              break;
            }

            _context10.next = 65;
            return tokenizer.readBuffer(buffer, {
              length: 30
            });

          case 65:
            // https://en.wikipedia.org/wiki/Zip_(file_format)#File_headers
            zipHeader = {
              compressedSize: buffer.readUInt32LE(18),
              uncompressedSize: buffer.readUInt32LE(22),
              filenameLength: buffer.readUInt16LE(26),
              extraFieldLength: buffer.readUInt16LE(28)
            };
            _context10.next = 68;
            return tokenizer.readToken(new Token.StringType(zipHeader.filenameLength, 'utf-8'));

          case 68:
            zipHeader.filename = _context10.sent;
            _context10.next = 71;
            return tokenizer.ignore(zipHeader.extraFieldLength);

          case 71:
            if (!(zipHeader.filename === 'META-INF/mozilla.rsa')) {
              _context10.next = 73;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'xpi',
              mime: 'application/x-xpinstall'
            });

          case 73:
            if (!(zipHeader.filename.endsWith('.rels') || zipHeader.filename.endsWith('.xml'))) {
              _context10.next = 83;
              break;
            }

            type = zipHeader.filename.split('/')[0];
            _context10.t0 = type;
            _context10.next = _context10.t0 === '_rels' ? 78 : _context10.t0 === 'word' ? 79 : _context10.t0 === 'ppt' ? 80 : _context10.t0 === 'xl' ? 81 : 82;
            break;

          case 78:
            return _context10.abrupt("break", 83);

          case 79:
            return _context10.abrupt("return", {
              ext: 'docx',
              mime: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            });

          case 80:
            return _context10.abrupt("return", {
              ext: 'pptx',
              mime: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
            });

          case 81:
            return _context10.abrupt("return", {
              ext: 'xlsx',
              mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });

          case 82:
            return _context10.abrupt("break", 83);

          case 83:
            if (!zipHeader.filename.startsWith('xl/')) {
              _context10.next = 85;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'xlsx',
              mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });

          case 85:
            if (!(zipHeader.filename.startsWith('3D/') && zipHeader.filename.endsWith('.model'))) {
              _context10.next = 87;
              break;
            }

            return _context10.abrupt("return", {
              ext: '3mf',
              mime: 'model/3mf'
            });

          case 87:
            if (!(zipHeader.filename === 'mimetype' && zipHeader.compressedSize === zipHeader.uncompressedSize)) {
              _context10.next = 98;
              break;
            }

            _context10.next = 90;
            return tokenizer.readToken(new Token.StringType(zipHeader.compressedSize, 'utf-8'));

          case 90:
            mimeType = _context10.sent;
            _context10.t1 = mimeType;
            _context10.next = _context10.t1 === 'application/epub+zip' ? 94 : _context10.t1 === 'application/vnd.oasis.opendocument.text' ? 95 : _context10.t1 === 'application/vnd.oasis.opendocument.spreadsheet' ? 96 : _context10.t1 === 'application/vnd.oasis.opendocument.presentation' ? 97 : 98;
            break;

          case 94:
            return _context10.abrupt("return", {
              ext: 'epub',
              mime: 'application/epub+zip'
            });

          case 95:
            return _context10.abrupt("return", {
              ext: 'odt',
              mime: 'application/vnd.oasis.opendocument.text'
            });

          case 96:
            return _context10.abrupt("return", {
              ext: 'ods',
              mime: 'application/vnd.oasis.opendocument.spreadsheet'
            });

          case 97:
            return _context10.abrupt("return", {
              ext: 'odp',
              mime: 'application/vnd.oasis.opendocument.presentation'
            });

          case 98:
            if (!(zipHeader.compressedSize === 0)) {
              _context10.next = 110;
              break;
            }

            nextHeaderIndex = -1;

          case 100:
            if (!(nextHeaderIndex < 0 && tokenizer.position < tokenizer.fileInfo.size)) {
              _context10.next = 108;
              break;
            }

            _context10.next = 103;
            return tokenizer.peekBuffer(buffer, {
              mayBeLess: true
            });

          case 103:
            nextHeaderIndex = buffer.indexOf('504B0304', 0, 'hex'); // Move position to the next header if found, skip the whole buffer otherwise

            _context10.next = 106;
            return tokenizer.ignore(nextHeaderIndex >= 0 ? nextHeaderIndex : buffer.length);

          case 106:
            _context10.next = 100;
            break;

          case 108:
            _context10.next = 112;
            break;

          case 110:
            _context10.next = 112;
            return tokenizer.ignore(zipHeader.compressedSize);

          case 112:
            _context10.next = 62;
            break;

          case 114:
            _context10.next = 120;
            break;

          case 116:
            _context10.prev = 116;
            _context10.t2 = _context10["catch"](61);

            if (_context10.t2 instanceof strtok3.EndOfStreamError) {
              _context10.next = 120;
              break;
            }

            throw _context10.t2;

          case 120:
            return _context10.abrupt("return", {
              ext: 'zip',
              mime: 'application/zip'
            });

          case 121:
            if (!checkString('OggS')) {
              _context10.next = 140;
              break;
            }

            _context10.next = 124;
            return tokenizer.ignore(28);

          case 124:
            _type = Buffer.alloc(8);
            _context10.next = 127;
            return tokenizer.readBuffer(_type);

          case 127:
            if (!_check(_type, [0x4F, 0x70, 0x75, 0x73, 0x48, 0x65, 0x61, 0x64])) {
              _context10.next = 129;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'opus',
              mime: 'audio/opus'
            });

          case 129:
            if (!_check(_type, [0x80, 0x74, 0x68, 0x65, 0x6F, 0x72, 0x61])) {
              _context10.next = 131;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'ogv',
              mime: 'video/ogg'
            });

          case 131:
            if (!_check(_type, [0x01, 0x76, 0x69, 0x64, 0x65, 0x6F, 0x00])) {
              _context10.next = 133;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'ogm',
              mime: 'video/ogg'
            });

          case 133:
            if (!_check(_type, [0x7F, 0x46, 0x4C, 0x41, 0x43])) {
              _context10.next = 135;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'oga',
              mime: 'audio/ogg'
            });

          case 135:
            if (!_check(_type, [0x53, 0x70, 0x65, 0x65, 0x78, 0x20, 0x20])) {
              _context10.next = 137;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'spx',
              mime: 'audio/ogg'
            });

          case 137:
            if (!_check(_type, [0x01, 0x76, 0x6F, 0x72, 0x62, 0x69, 0x73])) {
              _context10.next = 139;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'ogg',
              mime: 'audio/ogg'
            });

          case 139:
            return _context10.abrupt("return", {
              ext: 'ogx',
              mime: 'application/ogg'
            });

          case 140:
            if (!(check([0x50, 0x4B]) && (buffer[2] === 0x3 || buffer[2] === 0x5 || buffer[2] === 0x7) && (buffer[3] === 0x4 || buffer[3] === 0x6 || buffer[3] === 0x8))) {
              _context10.next = 142;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'zip',
              mime: 'application/zip'
            });

          case 142:
            if (!(checkString('ftyp', {
              offset: 4
            }) && (buffer[8] & 0x60) !== 0x00 // Brand major, first character ASCII?
            )) {
              _context10.next = 167;
              break;
            }

            // They all can have MIME `video/mp4` except `application/mp4` special-case which is hard to detect.
            // For some cases, we're specific, everything else falls to `video/mp4` with `mp4` extension.
            brandMajor = buffer.toString('binary', 8, 12).replace('\0', ' ').trim();
            _context10.t3 = brandMajor;
            _context10.next = _context10.t3 === 'avif' ? 147 : _context10.t3 === 'mif1' ? 148 : _context10.t3 === 'msf1' ? 149 : _context10.t3 === 'heic' ? 150 : _context10.t3 === 'heix' ? 150 : _context10.t3 === 'hevc' ? 151 : _context10.t3 === 'hevx' ? 151 : _context10.t3 === 'qt' ? 152 : _context10.t3 === 'M4V' ? 153 : _context10.t3 === 'M4VH' ? 153 : _context10.t3 === 'M4VP' ? 153 : _context10.t3 === 'M4P' ? 154 : _context10.t3 === 'M4B' ? 155 : _context10.t3 === 'M4A' ? 156 : _context10.t3 === 'F4V' ? 157 : _context10.t3 === 'F4P' ? 158 : _context10.t3 === 'F4A' ? 159 : _context10.t3 === 'F4B' ? 160 : _context10.t3 === 'crx' ? 161 : 162;
            break;

          case 147:
            return _context10.abrupt("return", {
              ext: 'avif',
              mime: 'image/avif'
            });

          case 148:
            return _context10.abrupt("return", {
              ext: 'heic',
              mime: 'image/heif'
            });

          case 149:
            return _context10.abrupt("return", {
              ext: 'heic',
              mime: 'image/heif-sequence'
            });

          case 150:
            return _context10.abrupt("return", {
              ext: 'heic',
              mime: 'image/heic'
            });

          case 151:
            return _context10.abrupt("return", {
              ext: 'heic',
              mime: 'image/heic-sequence'
            });

          case 152:
            return _context10.abrupt("return", {
              ext: 'mov',
              mime: 'video/quicktime'
            });

          case 153:
            return _context10.abrupt("return", {
              ext: 'm4v',
              mime: 'video/x-m4v'
            });

          case 154:
            return _context10.abrupt("return", {
              ext: 'm4p',
              mime: 'video/mp4'
            });

          case 155:
            return _context10.abrupt("return", {
              ext: 'm4b',
              mime: 'audio/mp4'
            });

          case 156:
            return _context10.abrupt("return", {
              ext: 'm4a',
              mime: 'audio/x-m4a'
            });

          case 157:
            return _context10.abrupt("return", {
              ext: 'f4v',
              mime: 'video/mp4'
            });

          case 158:
            return _context10.abrupt("return", {
              ext: 'f4p',
              mime: 'video/mp4'
            });

          case 159:
            return _context10.abrupt("return", {
              ext: 'f4a',
              mime: 'audio/mp4'
            });

          case 160:
            return _context10.abrupt("return", {
              ext: 'f4b',
              mime: 'audio/mp4'
            });

          case 161:
            return _context10.abrupt("return", {
              ext: 'cr3',
              mime: 'image/x-canon-cr3'
            });

          case 162:
            if (!brandMajor.startsWith('3g')) {
              _context10.next = 166;
              break;
            }

            if (!brandMajor.startsWith('3g2')) {
              _context10.next = 165;
              break;
            }

            return _context10.abrupt("return", {
              ext: '3g2',
              mime: 'video/3gpp2'
            });

          case 165:
            return _context10.abrupt("return", {
              ext: '3gp',
              mime: 'video/3gpp'
            });

          case 166:
            return _context10.abrupt("return", {
              ext: 'mp4',
              mime: 'video/mp4'
            });

          case 167:
            if (!checkString('MThd')) {
              _context10.next = 169;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'mid',
              mime: 'audio/midi'
            });

          case 169:
            if (!(checkString('wOFF') && (check([0x00, 0x01, 0x00, 0x00], {
              offset: 4
            }) || checkString('OTTO', {
              offset: 4
            })))) {
              _context10.next = 171;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'woff',
              mime: 'font/woff'
            });

          case 171:
            if (!(checkString('wOF2') && (check([0x00, 0x01, 0x00, 0x00], {
              offset: 4
            }) || checkString('OTTO', {
              offset: 4
            })))) {
              _context10.next = 173;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'woff2',
              mime: 'font/woff2'
            });

          case 173:
            if (!(check([0xD4, 0xC3, 0xB2, 0xA1]) || check([0xA1, 0xB2, 0xC3, 0xD4]))) {
              _context10.next = 175;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'pcap',
              mime: 'application/vnd.tcpdump.pcap'
            });

          case 175:
            if (!checkString('DSD ')) {
              _context10.next = 177;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'dsf',
              mime: 'audio/x-dsf' // Non-standard

            });

          case 177:
            if (!checkString('LZIP')) {
              _context10.next = 179;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'lz',
              mime: 'application/x-lzip'
            });

          case 179:
            if (!checkString('fLaC')) {
              _context10.next = 181;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'flac',
              mime: 'audio/x-flac'
            });

          case 181:
            if (!check([0x42, 0x50, 0x47, 0xFB])) {
              _context10.next = 183;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'bpg',
              mime: 'image/bpg'
            });

          case 183:
            if (!checkString('wvpk')) {
              _context10.next = 185;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'wv',
              mime: 'audio/wavpack'
            });

          case 185:
            if (!checkString('%PDF')) {
              _context10.next = 195;
              break;
            }

            _context10.next = 188;
            return tokenizer.ignore(1350);

          case 188:
            maxBufferSize = 10 * 1024 * 1024;
            _buffer = Buffer.alloc(Math.min(maxBufferSize, tokenizer.fileInfo.size));
            _context10.next = 192;
            return tokenizer.readBuffer(_buffer, {
              mayBeLess: true
            });

          case 192:
            if (!_buffer.includes(Buffer.from('AIPrivateData'))) {
              _context10.next = 194;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'ai',
              mime: 'application/postscript'
            });

          case 194:
            return _context10.abrupt("return", {
              ext: 'pdf',
              mime: 'application/pdf'
            });

          case 195:
            if (!check([0x00, 0x61, 0x73, 0x6D])) {
              _context10.next = 197;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'wasm',
              mime: 'application/wasm'
            });

          case 197:
            if (!check([0x49, 0x49, 0x2A, 0x0])) {
              _context10.next = 210;
              break;
            }

            if (!checkString('CR', {
              offset: 8
            })) {
              _context10.next = 200;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'cr2',
              mime: 'image/x-canon-cr2'
            });

          case 200:
            if (!(check([0x1C, 0x00, 0xFE, 0x00], {
              offset: 8
            }) || check([0x1F, 0x00, 0x0B, 0x00], {
              offset: 8
            }))) {
              _context10.next = 202;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'nef',
              mime: 'image/x-nikon-nef'
            });

          case 202:
            if (!(check([0x08, 0x00, 0x00, 0x00], {
              offset: 4
            }) && (check([0x2D, 0x00, 0xFE, 0x00], {
              offset: 8
            }) || check([0x27, 0x00, 0xFE, 0x00], {
              offset: 8
            })))) {
              _context10.next = 204;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'dng',
              mime: 'image/x-adobe-dng'
            });

          case 204:
            buffer = Buffer.alloc(24);
            _context10.next = 207;
            return tokenizer.peekBuffer(buffer);

          case 207:
            if (!((check([0x10, 0xFB, 0x86, 0x01], {
              offset: 4
            }) || check([0x08, 0x00, 0x00, 0x00], {
              offset: 4
            })) && // This pattern differentiates ARW from other TIFF-ish file types:
            check([0x00, 0xFE, 0x00, 0x04, 0x00, 0x01, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x03, 0x01], {
              offset: 9
            }))) {
              _context10.next = 209;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'arw',
              mime: 'image/x-sony-arw'
            });

          case 209:
            return _context10.abrupt("return", {
              ext: 'tif',
              mime: 'image/tiff'
            });

          case 210:
            if (!check([0x4D, 0x4D, 0x0, 0x2A])) {
              _context10.next = 212;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'tif',
              mime: 'image/tiff'
            });

          case 212:
            if (!checkString('MAC ')) {
              _context10.next = 214;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'ape',
              mime: 'audio/ape'
            });

          case 214:
            if (!check([0x1A, 0x45, 0xDF, 0xA3])) {
              _context10.next = 230;
              break;
            }

            // Root element: EBML
            readField = /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                var msb, mask, ic, id;
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return tokenizer.peekNumber(Token.UINT8);

                      case 2:
                        msb = _context5.sent;
                        mask = 0x80;
                        ic = 0; // 0 = A, 1 = B, 2 = C, 3 = D

                        while ((msb & mask) === 0) {
                          ++ic;
                          mask >>= 1;
                        }

                        id = Buffer.alloc(ic + 1);
                        _context5.next = 9;
                        return tokenizer.readBuffer(id);

                      case 9:
                        return _context5.abrupt("return", id);

                      case 10:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              }));

              return function readField() {
                return _ref2.apply(this, arguments);
              };
            }();

            readElement = /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                var id, lenField, nrLen;
                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        _context6.next = 2;
                        return readField();

                      case 2:
                        id = _context6.sent;
                        _context6.next = 5;
                        return readField();

                      case 5:
                        lenField = _context6.sent;
                        lenField[0] ^= 0x80 >> lenField.length - 1;
                        nrLen = Math.min(6, lenField.length); // JavaScript can max read 6 bytes integer

                        return _context6.abrupt("return", {
                          id: id.readUIntBE(0, id.length),
                          len: lenField.readUIntBE(lenField.length - nrLen, nrLen)
                        });

                      case 9:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee6);
              }));

              return function readElement() {
                return _ref3.apply(this, arguments);
              };
            }();

            readChildren = /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(level, children) {
                var e;
                return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        if (!(children > 0)) {
                          _context7.next = 11;
                          break;
                        }

                        _context7.next = 3;
                        return readElement();

                      case 3:
                        e = _context7.sent;

                        if (!(e.id === 0x4282)) {
                          _context7.next = 6;
                          break;
                        }

                        return _context7.abrupt("return", tokenizer.readToken(new Token.StringType(e.len, 'utf-8')));

                      case 6:
                        _context7.next = 8;
                        return tokenizer.ignore(e.len);

                      case 8:
                        // ignore payload
                        --children;
                        _context7.next = 0;
                        break;

                      case 11:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7);
              }));

              return function readChildren(_x5, _x6) {
                return _ref4.apply(this, arguments);
              };
            }();

            _context10.next = 220;
            return readElement();

          case 220:
            re = _context10.sent;
            _context10.next = 223;
            return readChildren(1, re.len);

          case 223:
            docType = _context10.sent;
            _context10.t4 = docType;
            _context10.next = _context10.t4 === 'webm' ? 227 : _context10.t4 === 'matroska' ? 228 : 229;
            break;

          case 227:
            return _context10.abrupt("return", {
              ext: 'webm',
              mime: 'video/webm'
            });

          case 228:
            return _context10.abrupt("return", {
              ext: 'mkv',
              mime: 'video/x-matroska'
            });

          case 229:
            return _context10.abrupt("return");

          case 230:
            if (!check([0x52, 0x49, 0x46, 0x46])) {
              _context10.next = 237;
              break;
            }

            if (!check([0x41, 0x56, 0x49], {
              offset: 8
            })) {
              _context10.next = 233;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'avi',
              mime: 'video/vnd.avi'
            });

          case 233:
            if (!check([0x57, 0x41, 0x56, 0x45], {
              offset: 8
            })) {
              _context10.next = 235;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'wav',
              mime: 'audio/vnd.wave'
            });

          case 235:
            if (!check([0x51, 0x4C, 0x43, 0x4D], {
              offset: 8
            })) {
              _context10.next = 237;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'qcp',
              mime: 'audio/qcelp'
            });

          case 237:
            if (!checkString('SQLi')) {
              _context10.next = 239;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'sqlite',
              mime: 'application/x-sqlite3'
            });

          case 239:
            if (!check([0x4E, 0x45, 0x53, 0x1A])) {
              _context10.next = 241;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'nes',
              mime: 'application/x-nintendo-nes-rom'
            });

          case 241:
            if (!checkString('Cr24')) {
              _context10.next = 243;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'crx',
              mime: 'application/x-google-chrome-extension'
            });

          case 243:
            if (!(checkString('MSCF') || checkString('ISc('))) {
              _context10.next = 245;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'cab',
              mime: 'application/vnd.ms-cab-compressed'
            });

          case 245:
            if (!check([0xED, 0xAB, 0xEE, 0xDB])) {
              _context10.next = 247;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'rpm',
              mime: 'application/x-rpm'
            });

          case 247:
            if (!check([0xC5, 0xD0, 0xD3, 0xC6])) {
              _context10.next = 249;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'eps',
              mime: 'application/eps'
            });

          case 249:
            if (!check([0x28, 0xB5, 0x2F, 0xFD])) {
              _context10.next = 251;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'zst',
              mime: 'application/zstd'
            });

          case 251:
            if (!check([0x4F, 0x54, 0x54, 0x4F, 0x00])) {
              _context10.next = 253;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'otf',
              mime: 'font/otf'
            });

          case 253:
            if (!checkString('#!AMR')) {
              _context10.next = 255;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'amr',
              mime: 'audio/amr'
            });

          case 255:
            if (!checkString('{\\rtf')) {
              _context10.next = 257;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'rtf',
              mime: 'application/rtf'
            });

          case 257:
            if (!check([0x46, 0x4C, 0x56, 0x01])) {
              _context10.next = 259;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'flv',
              mime: 'video/x-flv'
            });

          case 259:
            if (!checkString('IMPM')) {
              _context10.next = 261;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'it',
              mime: 'audio/x-it'
            });

          case 261:
            if (!(checkString('-lh0-', {
              offset: 2
            }) || checkString('-lh1-', {
              offset: 2
            }) || checkString('-lh2-', {
              offset: 2
            }) || checkString('-lh3-', {
              offset: 2
            }) || checkString('-lh4-', {
              offset: 2
            }) || checkString('-lh5-', {
              offset: 2
            }) || checkString('-lh6-', {
              offset: 2
            }) || checkString('-lh7-', {
              offset: 2
            }) || checkString('-lzs-', {
              offset: 2
            }) || checkString('-lz4-', {
              offset: 2
            }) || checkString('-lz5-', {
              offset: 2
            }) || checkString('-lhd-', {
              offset: 2
            }))) {
              _context10.next = 263;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'lzh',
              mime: 'application/x-lzh-compressed'
            });

          case 263:
            if (!check([0x00, 0x00, 0x01, 0xBA])) {
              _context10.next = 268;
              break;
            }

            if (!check([0x21], {
              offset: 4,
              mask: [0xF1]
            })) {
              _context10.next = 266;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'mpg',
              // May also be .ps, .mpeg
              mime: 'video/MP1S'
            });

          case 266:
            if (!check([0x44], {
              offset: 4,
              mask: [0xC4]
            })) {
              _context10.next = 268;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'mpg',
              // May also be .mpg, .m2p, .vob or .sub
              mime: 'video/MP2P'
            });

          case 268:
            if (!checkString('ITSF')) {
              _context10.next = 270;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'chm',
              mime: 'application/vnd.ms-htmlhelp'
            });

          case 270:
            if (!check([0xFD, 0x37, 0x7A, 0x58, 0x5A, 0x00])) {
              _context10.next = 272;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'xz',
              mime: 'application/x-xz'
            });

          case 272:
            if (!checkString('<?xml ')) {
              _context10.next = 274;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'xml',
              mime: 'application/xml'
            });

          case 274:
            if (!check([0x37, 0x7A, 0xBC, 0xAF, 0x27, 0x1C])) {
              _context10.next = 276;
              break;
            }

            return _context10.abrupt("return", {
              ext: '7z',
              mime: 'application/x-7z-compressed'
            });

          case 276:
            if (!(check([0x52, 0x61, 0x72, 0x21, 0x1A, 0x7]) && (buffer[6] === 0x0 || buffer[6] === 0x1))) {
              _context10.next = 278;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'rar',
              mime: 'application/x-rar-compressed'
            });

          case 278:
            if (!checkString('solid ')) {
              _context10.next = 280;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'stl',
              mime: 'model/stl'
            });

          case 280:
            if (!checkString('BLENDER')) {
              _context10.next = 282;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'blend',
              mime: 'application/x-blender'
            });

          case 282:
            if (!checkString('!<arch>')) {
              _context10.next = 291;
              break;
            }

            _context10.next = 285;
            return tokenizer.ignore(8);

          case 285:
            _context10.next = 287;
            return tokenizer.readToken(new Token.StringType(13, 'ascii'));

          case 287:
            str = _context10.sent;

            if (!(str === 'debian-binary')) {
              _context10.next = 290;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'deb',
              mime: 'application/x-deb'
            });

          case 290:
            return _context10.abrupt("return", {
              ext: 'ar',
              mime: 'application/x-unix-archive'
            });

          case 291:
            if (!check([0x89, 0x50, 0x4E, 0x47, 0x0D, 0x0A, 0x1A, 0x0A])) {
              _context10.next = 309;
              break;
            }

            // ignore PNG signature
            readChunkHeader = /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
                return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        _context8.next = 2;
                        return tokenizer.readToken(Token.INT32_BE);

                      case 2:
                        _context8.t0 = _context8.sent;
                        _context8.next = 5;
                        return tokenizer.readToken(new Token.StringType(4, 'binary'));

                      case 5:
                        _context8.t1 = _context8.sent;
                        return _context8.abrupt("return", {
                          length: _context8.t0,
                          type: _context8.t1
                        });

                      case 7:
                      case "end":
                        return _context8.stop();
                    }
                  }
                }, _callee8);
              }));

              return function readChunkHeader() {
                return _ref5.apply(this, arguments);
              };
            }();

            _context10.next = 295;
            return tokenizer.ignore(8);

          case 295:
            _context10.next = 297;
            return readChunkHeader();

          case 297:
            chunk = _context10.sent;

            if (!(chunk.length < 0)) {
              _context10.next = 300;
              break;
            }

            return _context10.abrupt("return");

          case 300:
            _context10.t5 = chunk.type;
            _context10.next = _context10.t5 === 'IDAT' ? 303 : _context10.t5 === 'acTL' ? 304 : 305;
            break;

          case 303:
            return _context10.abrupt("return", {
              ext: 'png',
              mime: 'image/png'
            });

          case 304:
            return _context10.abrupt("return", {
              ext: 'apng',
              mime: 'image/apng'
            });

          case 305:
            _context10.next = 307;
            return tokenizer.ignore(chunk.length + 4);

          case 307:
            if (tokenizer.position + 8 < tokenizer.fileInfo.size) {
              _context10.next = 295;
              break;
            }

          case 308:
            return _context10.abrupt("return", {
              ext: 'png',
              mime: 'image/png'
            });

          case 309:
            if (!check([0x41, 0x52, 0x52, 0x4F, 0x57, 0x31, 0x00, 0x00])) {
              _context10.next = 311;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'arrow',
              mime: 'application/x-apache-arrow'
            });

          case 311:
            if (!check([0x67, 0x6C, 0x54, 0x46, 0x02, 0x00, 0x00, 0x00])) {
              _context10.next = 313;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'glb',
              mime: 'model/gltf-binary'
            });

          case 313:
            if (!(check([0x66, 0x72, 0x65, 0x65], {
              offset: 4
            }) || // `free`
            check([0x6D, 0x64, 0x61, 0x74], {
              offset: 4
            }) || // `mdat` MJPEG
            check([0x6D, 0x6F, 0x6F, 0x76], {
              offset: 4
            }) || // `moov`
            check([0x77, 0x69, 0x64, 0x65], {
              offset: 4
            }) // `wide`
            )) {
              _context10.next = 315;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'mov',
              mime: 'video/quicktime'
            });

          case 315:
            if (!check([0x49, 0x49, 0x52, 0x4F, 0x08, 0x00, 0x00, 0x00, 0x18])) {
              _context10.next = 317;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'orf',
              mime: 'image/x-olympus-orf'
            });

          case 317:
            if (!checkString('gimp xcf ')) {
              _context10.next = 319;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'xcf',
              mime: 'image/x-xcf'
            });

          case 319:
            if (!check([0x49, 0x49, 0x55, 0x00, 0x18, 0x00, 0x00, 0x00, 0x88, 0xE7, 0x74, 0xD8])) {
              _context10.next = 321;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'rw2',
              mime: 'image/x-panasonic-rw2'
            });

          case 321:
            if (!check([0x30, 0x26, 0xB2, 0x75, 0x8E, 0x66, 0xCF, 0x11, 0xA6, 0xD9])) {
              _context10.next = 346;
              break;
            }

            readHeader = /*#__PURE__*/function () {
              var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
                var guid;
                return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        guid = Buffer.alloc(16);
                        _context9.next = 3;
                        return tokenizer.readBuffer(guid);

                      case 3:
                        _context9.t0 = guid;
                        _context9.t1 = Number;
                        _context9.next = 7;
                        return tokenizer.readToken(Token.UINT64_LE);

                      case 7:
                        _context9.t2 = _context9.sent;
                        _context9.t3 = (0, _context9.t1)(_context9.t2);
                        return _context9.abrupt("return", {
                          id: _context9.t0,
                          size: _context9.t3
                        });

                      case 10:
                      case "end":
                        return _context9.stop();
                    }
                  }
                }, _callee9);
              }));

              return function readHeader() {
                return _ref6.apply(this, arguments);
              };
            }();

            _context10.next = 325;
            return tokenizer.ignore(30);

          case 325:
            if (!(tokenizer.position + 24 < tokenizer.fileInfo.size)) {
              _context10.next = 345;
              break;
            }

            _context10.next = 328;
            return readHeader();

          case 328:
            header = _context10.sent;
            payload = header.size - 24;

            if (!_check(header.id, [0x91, 0x07, 0xDC, 0xB7, 0xB7, 0xA9, 0xCF, 0x11, 0x8E, 0xE6, 0x00, 0xC0, 0x0C, 0x20, 0x53, 0x65])) {
              _context10.next = 341;
              break;
            }

            // Sync on Stream-Properties-Object (B7DC0791-A9B7-11CF-8EE6-00C00C205365)
            typeId = Buffer.alloc(16);
            _context10.t6 = payload;
            _context10.next = 335;
            return tokenizer.readBuffer(typeId);

          case 335:
            payload = _context10.t6 -= _context10.sent;

            if (!_check(typeId, [0x40, 0x9E, 0x69, 0xF8, 0x4D, 0x5B, 0xCF, 0x11, 0xA8, 0xFD, 0x00, 0x80, 0x5F, 0x5C, 0x44, 0x2B])) {
              _context10.next = 338;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'asf',
              mime: 'audio/x-ms-asf'
            });

          case 338:
            if (!_check(typeId, [0xC0, 0xEF, 0x19, 0xBC, 0x4D, 0x5B, 0xCF, 0x11, 0xA8, 0xFD, 0x00, 0x80, 0x5F, 0x5C, 0x44, 0x2B])) {
              _context10.next = 340;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'asf',
              mime: 'video/x-ms-asf'
            });

          case 340:
            return _context10.abrupt("break", 345);

          case 341:
            _context10.next = 343;
            return tokenizer.ignore(payload);

          case 343:
            _context10.next = 325;
            break;

          case 345:
            return _context10.abrupt("return", {
              ext: 'asf',
              mime: 'application/vnd.ms-asf'
            });

          case 346:
            if (!check([0xAB, 0x4B, 0x54, 0x58, 0x20, 0x31, 0x31, 0xBB, 0x0D, 0x0A, 0x1A, 0x0A])) {
              _context10.next = 348;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'ktx',
              mime: 'image/ktx'
            });

          case 348:
            if (!((check([0x7E, 0x10, 0x04]) || check([0x7E, 0x18, 0x04])) && check([0x30, 0x4D, 0x49, 0x45], {
              offset: 4
            }))) {
              _context10.next = 350;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'mie',
              mime: 'application/x-mie'
            });

          case 350:
            if (!check([0x27, 0x0A, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00], {
              offset: 2
            })) {
              _context10.next = 352;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'shp',
              mime: 'application/x-esri-shape'
            });

          case 352:
            if (!check([0x00, 0x00, 0x00, 0x0C, 0x6A, 0x50, 0x20, 0x20, 0x0D, 0x0A, 0x87, 0x0A])) {
              _context10.next = 366;
              break;
            }

            _context10.next = 355;
            return tokenizer.ignore(20);

          case 355:
            _context10.next = 357;
            return tokenizer.readToken(new Token.StringType(4, 'ascii'));

          case 357:
            _type2 = _context10.sent;
            _context10.t7 = _type2;
            _context10.next = _context10.t7 === 'jp2 ' ? 361 : _context10.t7 === 'jpx ' ? 362 : _context10.t7 === 'jpm ' ? 363 : _context10.t7 === 'mjp2' ? 364 : 365;
            break;

          case 361:
            return _context10.abrupt("return", {
              ext: 'jp2',
              mime: 'image/jp2'
            });

          case 362:
            return _context10.abrupt("return", {
              ext: 'jpx',
              mime: 'image/jpx'
            });

          case 363:
            return _context10.abrupt("return", {
              ext: 'jpm',
              mime: 'image/jpm'
            });

          case 364:
            return _context10.abrupt("return", {
              ext: 'mj2',
              mime: 'image/mj2'
            });

          case 365:
            return _context10.abrupt("return");

          case 366:
            if (!(check([0xFF, 0x0A]) || check([0x00, 0x00, 0x00, 0x0C, 0x4A, 0x58, 0x4C, 0x20, 0x0D, 0x0A, 0x87, 0x0A]))) {
              _context10.next = 368;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'jxl',
              mime: 'image/jxl'
            });

          case 368:
            if (!(check([0x0, 0x0, 0x1, 0xBA]) || check([0x0, 0x0, 0x1, 0xB3]))) {
              _context10.next = 370;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'mpg',
              mime: 'video/mpeg'
            });

          case 370:
            if (!check([0x00, 0x01, 0x00, 0x00, 0x00])) {
              _context10.next = 372;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'ttf',
              mime: 'font/ttf'
            });

          case 372:
            if (!check([0x00, 0x00, 0x01, 0x00])) {
              _context10.next = 374;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'ico',
              mime: 'image/x-icon'
            });

          case 374:
            if (!check([0x00, 0x00, 0x02, 0x00])) {
              _context10.next = 376;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'cur',
              mime: 'image/x-icon'
            });

          case 376:
            if (!check([0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1])) {
              _context10.next = 378;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'cfb',
              mime: 'application/x-cfb'
            });

          case 378:
            _context10.next = 380;
            return tokenizer.peekBuffer(buffer, {
              length: Math.min(256, tokenizer.fileInfo.size),
              mayBeLess: true
            });

          case 380:
            if (!checkString('BEGIN:')) {
              _context10.next = 385;
              break;
            }

            if (!checkString('VCARD', {
              offset: 6
            })) {
              _context10.next = 383;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'vcf',
              mime: 'text/vcard'
            });

          case 383:
            if (!checkString('VCALENDAR', {
              offset: 6
            })) {
              _context10.next = 385;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'ics',
              mime: 'text/calendar'
            });

          case 385:
            if (!checkString('FUJIFILMCCD-RAW')) {
              _context10.next = 387;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'raf',
              mime: 'image/x-fujifilm-raf'
            });

          case 387:
            if (!checkString('Extended Module:')) {
              _context10.next = 389;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'xm',
              mime: 'audio/x-xm'
            });

          case 389:
            if (!checkString('Creative Voice File')) {
              _context10.next = 391;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'voc',
              mime: 'audio/x-voc'
            });

          case 391:
            if (!(check([0x04, 0x00, 0x00, 0x00]) && buffer.length >= 16)) {
              _context10.next = 403;
              break;
            }

            // Rough & quick check Pickle/ASAR
            jsonSize = buffer.readUInt32LE(12);

            if (!(jsonSize > 12 && buffer.length >= jsonSize + 16)) {
              _context10.next = 403;
              break;
            }

            _context10.prev = 394;
            _header = buffer.slice(16, jsonSize + 16).toString();
            json = JSON.parse(_header); // Check if Pickle is ASAR

            if (!json.files) {
              _context10.next = 399;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'asar',
              mime: 'application/x-asar'
            });

          case 399:
            _context10.next = 403;
            break;

          case 401:
            _context10.prev = 401;
            _context10.t8 = _context10["catch"](394);

          case 403:
            if (!check([0x06, 0x0E, 0x2B, 0x34, 0x02, 0x05, 0x01, 0x01, 0x0D, 0x01, 0x02, 0x01, 0x01, 0x02])) {
              _context10.next = 405;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'mxf',
              mime: 'application/mxf'
            });

          case 405:
            if (!checkString('SCRM', {
              offset: 44
            })) {
              _context10.next = 407;
              break;
            }

            return _context10.abrupt("return", {
              ext: 's3m',
              mime: 'audio/x-s3m'
            });

          case 407:
            if (!(check([0x47], {
              offset: 4
            }) && (check([0x47], {
              offset: 192
            }) || check([0x47], {
              offset: 196
            })))) {
              _context10.next = 409;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'mts',
              mime: 'video/mp2t'
            });

          case 409:
            if (!check([0x42, 0x4F, 0x4F, 0x4B, 0x4D, 0x4F, 0x42, 0x49], {
              offset: 60
            })) {
              _context10.next = 411;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'mobi',
              mime: 'application/x-mobipocket-ebook'
            });

          case 411:
            if (!check([0x44, 0x49, 0x43, 0x4D], {
              offset: 128
            })) {
              _context10.next = 413;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'dcm',
              mime: 'application/dicom'
            });

          case 413:
            if (!check([0x4C, 0x00, 0x00, 0x00, 0x01, 0x14, 0x02, 0x00, 0x00, 0x00, 0x00, 0x00, 0xC0, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x46])) {
              _context10.next = 415;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'lnk',
              mime: 'application/x.ms.shortcut' // Invented by us

            });

          case 415:
            if (!check([0x62, 0x6F, 0x6F, 0x6B, 0x00, 0x00, 0x00, 0x00, 0x6D, 0x61, 0x72, 0x6B, 0x00, 0x00, 0x00, 0x00])) {
              _context10.next = 417;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'alias',
              mime: 'application/x.apple.alias' // Invented by us

            });

          case 417:
            if (!(check([0x4C, 0x50], {
              offset: 34
            }) && (check([0x00, 0x00, 0x01], {
              offset: 8
            }) || check([0x01, 0x00, 0x02], {
              offset: 8
            }) || check([0x02, 0x00, 0x02], {
              offset: 8
            })))) {
              _context10.next = 419;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'eot',
              mime: 'application/vnd.ms-fontobject'
            });

          case 419:
            if (!check([0x06, 0x06, 0xED, 0xF5, 0xD8, 0x1D, 0x46, 0xE5, 0xBD, 0x31, 0xEF, 0xE7, 0xFE, 0x74, 0xB7, 0x1D])) {
              _context10.next = 421;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'indd',
              mime: 'application/x-indesign'
            });

          case 421:
            _context10.next = 423;
            return tokenizer.peekBuffer(buffer, {
              length: Math.min(512, tokenizer.fileInfo.size),
              mayBeLess: true
            });

          case 423:
            if (!tarHeaderChecksumMatches(buffer)) {
              _context10.next = 425;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'tar',
              mime: 'application/x-tar'
            });

          case 425:
            if (!check([0xFF, 0xFE, 0xFF, 0x0E, 0x53, 0x00, 0x6B, 0x00, 0x65, 0x00, 0x74, 0x00, 0x63, 0x00, 0x68, 0x00, 0x55, 0x00, 0x70, 0x00, 0x20, 0x00, 0x4D, 0x00, 0x6F, 0x00, 0x64, 0x00, 0x65, 0x00, 0x6C, 0x00])) {
              _context10.next = 427;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'skp',
              mime: 'application/vnd.sketchup.skp'
            });

          case 427:
            if (!checkString('-----BEGIN PGP MESSAGE-----')) {
              _context10.next = 429;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'pgp',
              mime: 'application/pgp-encrypted'
            });

          case 429:
            if (!(buffer.length >= 2 && check([0xFF, 0xE0], {
              offset: 0,
              mask: [0xFF, 0xE0]
            }))) {
              _context10.next = 440;
              break;
            }

            if (!check([0x10], {
              offset: 1,
              mask: [0x16]
            })) {
              _context10.next = 434;
              break;
            }

            if (!check([0x08], {
              offset: 1,
              mask: [0x08]
            })) {
              _context10.next = 433;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'aac',
              mime: 'audio/aac'
            });

          case 433:
            return _context10.abrupt("return", {
              ext: 'aac',
              mime: 'audio/aac'
            });

          case 434:
            if (!check([0x02], {
              offset: 1,
              mask: [0x06]
            })) {
              _context10.next = 436;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'mp3',
              mime: 'audio/mpeg'
            });

          case 436:
            if (!check([0x04], {
              offset: 1,
              mask: [0x06]
            })) {
              _context10.next = 438;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'mp2',
              mime: 'audio/mpeg'
            });

          case 438:
            if (!check([0x06], {
              offset: 1,
              mask: [0x06]
            })) {
              _context10.next = 440;
              break;
            }

            return _context10.abrupt("return", {
              ext: 'mp1',
              mime: 'audio/mpeg'
            });

          case 440:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[61, 116], [394, 401]]);
  }));
  return _fromTokenizer3.apply(this, arguments);
}

var stream = function stream(readableStream) {
  return new Promise(function (resolve, reject) {
    // Using `eval` to work around issues when bundling with Webpack
    var stream = eval('require')('stream'); // eslint-disable-line no-eval

    readableStream.on('error', reject);
    readableStream.once('readable', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var pass, outputStream, chunk, _fileType;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Set up output stream
              pass = new stream.PassThrough();

              if (stream.pipeline) {
                outputStream = stream.pipeline(readableStream, pass, function () {});
              } else {
                outputStream = readableStream.pipe(pass);
              } // Read the input stream and detect the filetype


              chunk = readableStream.read(minimumBytes) || readableStream.read() || Buffer.alloc(0);
              _context.prev = 3;
              _context.next = 6;
              return fromBuffer(chunk);

            case 6:
              _fileType = _context.sent;
              pass.fileType = _fileType;
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);
              reject(_context.t0);

            case 13:
              resolve(outputStream);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 10]]);
    })));
  });
};

var fileType = {
  fromStream: fromStream,
  fromTokenizer: fromTokenizer,
  fromBuffer: fromBuffer,
  stream: stream
};
Object.defineProperty(fileType, 'extensions', {
  get: function get() {
    return new Set(supported.extensions);
  }
});
Object.defineProperty(fileType, 'mimeTypes', {
  get: function get() {
    return new Set(supported.mimeTypes);
  }
});
module.exports = fileType;